<template>
  <div>
    <v-dialog v-model="isOpen" width="500" persistent>
      <v-card>
        <div class="modal-body">
          <v-btn icon @click="onClose" class="modal-close-icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title
            class="headline white modal-title green--text"
            primary-title
          >
            {{ title }}
          </v-card-title>
          <p>Payment Method</p>
          <v-select
            solo
            outline
            label="Payment Method"
            v-model="paymentMethod"
            @change="onChange"
            :items="listPaymentMethod"
            :rules="[v => !!v || 'Payment Method is required.']"
          >
          </v-select>
          <p>Amount</p>
          <CurrencyInput
            v-model="amount"
            singleLine
            label="Rp1.000.000"
            :isDisabled="isDisabledAmountInput"
          />
          <i
            v-bind:class="{
              'red--text': isDisableSubmit,
              'grey--text': !isDisableSubmit
            }"
          >
            <small>
              {{ amountAdditionalInformation }}
            </small>
          </i>
          <div class="pa-3 grey lighten-3 d-flex fee-payment">
            <label class="grey--text">+Fee Payment</label>
            <label class="green--text"> {{ currencyRupiah(feePayment) }}</label>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 green base">
          <div class="text-xs-left">
            <p class="mb-0">Total Amount</p>
            <p class="font-weight-bold subheading">
              {{ currencyRupiah(amount + feePayment) }}
            </p>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            class="grey lighten-4 green--text text-capitalize"
            round
            @click="onTopUp"
            :disabled="isDisableSubmit"
          >
            Pay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CurrencyInput from './CurrencyInput'
import { currencyRupiah } from '@/helpers/currency'

export default {
  name: 'TopUpModal',
  components: { CurrencyInput },
  data () {
    return {
      paymentMethod: null,
      amount: 0,
      feePayment: 0,
      minAmount: 0,
      maxAmount: 0,
      amountAdditionalInformation: '',
      isDisabledAmountInput: true
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    onSubmit: {
      type: Function,
      default: () => {}
    },
    listPaymentMethod: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isDisableSubmit () {
      return (
        this.amount < this.minAmount ||
        this.amount > this.maxAmount ||
        this.amount === 0 ||
        this.paymentMethod === 0 ||
        this.feePayment === 0
      )
    }
  },
  methods: {
    currencyRupiah,
    onTopUp () {
      const data = {
        amount: this.amount,
        paymentMethod: this.paymentMethod,
        feePayment: this.feePayment,
        totalAmount: this.amount + this.feePayment
      }
      this.onSubmit(data)
      this.onClear()
      this.onClose()
    },
    onClear () {
      this.amount = 1000000
    },
    onChange (id) {
      this.listPaymentMethod.map(item => {
        if (item.id === id) {
          this.feePayment = Number(item.payment_fee)
          this.amount = Number(item.minimum_amount)
          this.minAmount = Number(item.minimum_amount)
          this.maxAmount = Number(item.maximum_amount)
          this.amountAdditionalInformation = `Masukkan nominal antara
               ${currencyRupiah(this.minAmount)} - 
               ${currencyRupiah(this.maxAmount)}`
          this.isDisabledAmountInput = false
        }
      })
    }
  }
}
</script>
<style scoped>
.modal-body {
  padding: 2em;
  text-align: left;
}

.modal-close-icon {
  float: right;
}

.modal-title {
  font-weight: 600;
  font-size: 1.5em !important;
}

.v-card__title {
  padding: 0;
  margin-bottom: 2em;
  margin-top: 2em;
}

.fee-payment {
  border-radius: 5px;
  margin-top: 2em;
  margin-bottom: 2em;
}
</style>
